import React, { useContext } from 'react'
import RSRLHorizontalBar from './RSRLHorizontalBar'
import { useStaticQuery, graphql } from 'gatsby'

import { AccordionContext } from '../AccordionPage'

export default props => {
  const data = useStaticQuery(query)
  const edges = data.allRsrlSoinsPaliatifsXlsxOrigine.edges
  const page = props.page

  let labels = edges.map((row, i) => row.node.LIEU)
  let values = edges.map((row, i) => row.node.NOMBRE)
  let backgroundColor = edges.map((row, i) => row.node.BACKGROUND_COLOR)

  return (
    <div className="text-content">
      <div className="item-title">
        <h2 dangerouslySetInnerHTML={{ __html: page.acf.subtitle }} />
      </div>
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.acf.headlines }}
      />
      <div
        className="beforeCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
      <RSRLHorizontalBar
        label={''}
        labels={labels}
        values={values}
        backgroundColor={backgroundColor}
        xlabel={'N=409'}
        // ylabel={'Nombre de personnes'}
        // xlabel={'Âge'}
      />
      <div
        className="afterCanvas"
        dangerouslySetInnerHTML={{ __html: page.content }}
      />
    </div>
  )
}

const query = graphql`
  query {
    allRsrlSoinsPaliatifsXlsxOrigine{
      edges {
        node {
          LIEU
          NOMBRE
          BACKGROUND_COLOR
        }
      }
    }
  }
`
